import React from 'react';
import { NavLink } from 'react-router-dom';
import layoutStyles from '../../styles/sidebarLayout.module.scss';
import { InitiativeSummary } from '../../components/habitsDashboard/InitiativeSummary/InitiativeSummary';

const InitiativeSummaryPage = () => {
  return (
    <div className={layoutStyles.page}>
      <div className={layoutStyles.pageContainer}>
        {/* Sidebar with vertical tabs */}
        <aside className={layoutStyles.sidebar}>
          <nav className={layoutStyles.sidebarNav}>
            <NavLink
              to="/summary"
              className={({ isActive }) =>
                `${layoutStyles.sidebarTab} ${isActive ? layoutStyles.active : ''}`
              }
            >
              Objectives
            </NavLink>
            <NavLink
              to="/initiative-summary"
              end
              className={({ isActive }) =>
                `${layoutStyles.sidebarTab} ${isActive ? layoutStyles.active : ''}`
              }
            >
              Initiative summary
            </NavLink>
          </nav>
        </aside>

        {/* Main content */}
        <main className={layoutStyles.mainContent}>
          <div className={layoutStyles.tabContent}>
            <InitiativeSummary />
          </div>
        </main>
      </div>
    </div>
  );
};

export default InitiativeSummaryPage;
